const TestDomain = '99111126.wdn-h5.testing3.wdeduc.com';//本地测试Domain
let envArr = ['testing1', 'testing2', 'testing3', 'fat', 'uat'];
let env = window.location.port ? 'testing3' : '';
envArr.forEach(d => {
  if (location.hostname.includes(d)) {env = d}
})
let API = env ? `${location.protocol}//hrss-api.${env}.wdeduc.com` : `${location.protocol}//hrss-api.wdeduc.com`;
window.APP_BASE_URL = API ;
export default {
  API,
  TestDomain
};

